import { ref, watch } from '@vue/composition-api';
import { ObjectLike } from '@/types/objectlike.types';

const USERNAME_MAXLENGTH = 15;
const GAMERTAG_MAXLENGTH = 15;

export default function (
  signupVariables: ObjectLike,
  formRules: ObjectLike,
  signupTexts: ObjectLike,
) {
  const {
    required,
    maxLength,
    email,
    exact,
    password: passwordRule,
    username: usernameRule,
  } = formRules;

  const {
    usernameLabel,
    gamertagLabel,
    emailLabel,
    passwordLabel,
    passwordConfirmLabel,
  } = signupTexts;

  const { password } = signupVariables;

  const usernameRules = [
    ...required(usernameLabel),
    ...maxLength(usernameLabel, USERNAME_MAXLENGTH),
    ...usernameRule(usernameLabel),
  ];

  const gamertagRules = [
    ...required(gamertagLabel),
    ...maxLength(gamertagLabel, GAMERTAG_MAXLENGTH),
  ];

  const emailRules = [
    ...required(emailLabel),
    ...email(emailLabel),
  ];

  const passwordRules = [
    ...required(passwordLabel),
    ...passwordRule(passwordLabel),
  ];

  const passwordConfirmRules = ref([
    ...required(passwordConfirmLabel),
  ]);

  watch(password, () => {
    if (passwordConfirmRules.value.length === 2) {
      passwordConfirmRules.value.pop();
    }

    if (password.value) {
      passwordConfirmRules.value.push(
        ...exact(passwordConfirmLabel, password.value, passwordLabel),
      );
    }
  });

  return {
    usernameRules,
    gamertagRules,
    emailRules,
    passwordRules,
    passwordConfirmRules,
  };
}
